<template>
  <main>
    <div class="container-fluid p-0 mt-0">
      <section
        id="carousel"
        v-if="showCarousel && listaCarrosel && listaCarrosel.length"
      >
        <carousel
          :per-page="1"
          :mouse-drag="true"
          :autoplay="true"
          :loop="true"
          :transition="1000"
        >
          <slide v-for="(slide, index) of listaCarrosel" :key="index">
            <img
              @click="clickBanner(slide)"
              :src="slide.banner"
              style="width: 100%; object-fit: cover;"
              :class="{ 'cursor-pointer': slide.href || slide.url }"
            />
          </slide>
        </carousel>
      </section>
    </div>
    <div class="container">
      <section>
        <div class="assinatura row mt-5" v-if="objSignature">
          <!-- <Signature
            :objSignature="this.objSignature"
            :signatureModal="signatureModal"
          /> -->
          <NewSignature 
            :objSignature="this.objSignature"
            :signatureModal="signatureModal"
            :selectedPlan="selectedPlan"
            @update-plan="updateSelectedPlan"
          />
        </div>
      </section>
      <section id="produtos" v-if="MODULOS.MARKETPLACE && !loading">
        <!-- <div class="row">
          <div class="col-lg-12 mb-5"></div>
        </div> -->
        <div class="loja row mt-5" v-if="objProducts && computerProducts">
          <div
            v-if="lojaId"
            style="margin: -24px 0 12px; font-size: 0.8rem; color: #575757;"
          >
            <router-link :to="{ path: `/loja` }" tag="a" class="text-dark p-2">
              {{ CONFIG_NOME }}
            </router-link>
            <span>&#10097;</span>
            <span class="p-2 text-bold">{{ nomeLoja }}</span>
          </div>
          <article class="col-12" v-for="(produtos, i) in objProducts" :key="i">
            <Products
              :objProducts="produtos"
              :produtoModal="produtoModal"
              @modificaDetalhes="modificaDetalhes"
            />
          </article>
          <aside class="col-12">
            <Cart @modificaDetalhes="modificaDetalhes" />
          </aside>
        </div>
        <div
          v-else
          class="d-flex justify-content-center align-items-center flex-column font-weight-bold my-5 py-5"
        >
          <img
            src="https://pagglo-cdn.s3.amazonaws.com/app/assets/loading-circle-carousel.svg"
            style="width: 80px;"
          />
          CARREGANDO NOSSOS PRODUTOS
        </div>

        <ProductModal
          v-if="isOpen"
          :objDetalhes="objDetalhes"
          @toggleModal="toggleModal"
        />
      </section>
      <Loading v-if="loading"></Loading>
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
import Products from '@/components/Products.vue'
// import Signature from '@/components/Signature.vue'
import NewSignature from '@/components/NewSignature.vue'
import Cart from '@/components/Cart.vue'
import ProductModal from '@/components/ProductModal.vue'
import { APIService } from '../APIService'
import Loading from '@/components/Loading.vue'
const apiService = new APIService()

export default {
  name: 'Loja',
  components: {
    Products,
    // Signature,
    Cart,
    ProductModal,
    Loading,
    NewSignature,
  },
  data() {
    return {
      CONFIG_NOME: window.NOME,
      URL_SLUG: window.URL_SLUG,
      MODULOS: window.MODULOS,
      listaCarrosel: null,
      isOpen: false,
      objCategories: [],
      objSignature: null,
      nCategory: null,
      produtoModal: null,
      signatureModal: false,
      showCarousel: true,
      objDetalhes: {},
      objProducts: [],
      lojaId: null,
      nomeLoja: null,
      loading: false,
      tipoServico: null,
      objAssinaturas: null,
      objServicoPlano: null,
    }
  },
  created() {
    window.addEventListener('resize', this.refreshCarousel)
  },
  destroyed() {
    window.removeEventListener('resize', this.refreshCarousel)
  },
  watch: {
    '$route.params.lojaId': function (n) {
      if (+n !== this.lojaId) this.obterLoja(+n)
    },
    computerCategoriaSelecionada: function () {
      this.loading = true
      this.obterListaProdutos(
        this.$route.params.lojaId,
        this.$store.state.categoriaSelecionada,
      )
    },
    computerPesquisarProduto: function () {
      this.loading = true
      this.obterListaProdutosPorFiltroTexto(
        this.$route.params.lojaId,
        this.$store.state.pesquisarProduto,
      )
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    this.loading = true;

    if (
      this.MODULOS.LANDING_PAGE &&
      window.location.href.split('#')[1] == '/'
    ) {
      this.$router.push('/landing')
    } else if (
      !this.MODULOS.MARKETPLACE &&
      !this.MODULOS.ASSINATURA &&
      this.MODULOS.PORTAL_DO_CLIENTE
    ) {
      this.$router.push('/assinaturas')
    }

    localStorage.setItem('lpcid', this.$route.query.lpcid)
    localStorage.setItem('utm_source', this.$route.query.utm_source)
    localStorage.setItem(this.URL_SLUG, [])

    if (this.MODULOS.ASSINATURA) {
      this.loading = true;
      this.obterListaAssinaturas();
    } 

    this.listaCarrosel = window.BANNER_PRINCIPAL
  },
  methods: {
    async obterListaAssinaturas() {
      try {
        const response = await apiService.obterListaAssinaturas();
        this.objSignature = response;

        if (this.$route.query.planoId) {
          const token = localStorage.getItem("token");
          if (!token) {
            this.loading = false;
            return;
          }

          await this.processarAssinaturasUsuario();
        } else {
          this.loading = false;
        }

        if (window.PIXEL_CODE) {
          window.fbq('track', 'PageView');
        }
      } catch (error) {
        console.error('Erro ao obter lista de assinaturas:', error);
        this.loading = false;
      }
    },

    async processarAssinaturasUsuario() {
  try {
    const response = await apiService.obterMinhasAssinaturas();
    this.objAssinaturas = response;
    
    const planosOriginais = this.$route.query.planoId.split(',').map(Number);
    const codigoServico = this.$route.query.codigoServico;
    
    const planosAtivos = this.objAssinaturas.filter(o => planosOriginais.includes(o.id));

    if (this.objAssinaturas.length) {
      this.filtrarPlanosNaoAssinados();
    }

    if (planosAtivos.length > 0) {
      for (const planoAtivo of planosAtivos) {        
          await this.processarPlanoAtivo(planoAtivo, codigoServico);      
      }
    } else {
      this.loading = false;
    }
  } catch (error) {
    console.error('Erro ao processar assinaturas do usuário:', error);
    this.loading = false;
  }
},

    filtrarPlanosNaoAssinados() {
      const planosAssinados = new Set(this.objAssinaturas.map(o => o.id));
      this.objSignature = this.objSignature.filter(o => !planosAssinados.has(o.id));
      const planoId = Number(this.$route.query.planoId);
      if (planoId) {
        this.colocarPlanoNaPrimeiraPosicao(planoId);
      }
    },
    colocarPlanoNaPrimeiraPosicao(planoId) {
      const planoIndex = this.objSignature.findIndex(plano => plano.id === planoId);
      if (planoIndex !== -1) {
        const [plano] = this.objSignature.splice(planoIndex, 1);
        this.objSignature.unshift(plano);
        this.$emit('update-plan', this.selectedPlan);
      }
    },
    async processarPlanoAtivo(planoAtivo, codigoServico) {
      try {
        this.objSignature = this.objSignature.filter(o => o.id !== planoAtivo.id);
        const response = await apiService.obterServicosPlanoCliente(0, planoAtivo.id);
        this.objServicoPlano = response;
        this.objServicoPlano = this.objServicoPlano.filter(o => o.codigoServico === codigoServico);
        this.$router.push(`/plano-do-cliente/${planoAtivo.id}/${this.objServicoPlano[0].id}`);
      } catch (error) {
        this.loading = false;
      }
    },
    updateSelectedPlan(newPlan) {
      newPlan;
    },
    refreshCarousel() {
      this.showCarousel = false
      setTimeout(() => (this.showCarousel = true), 100)
    },
    toggleModal(action) {
      const el = document.body
      this.isOpen = action
      action
        ? el.classList.add('overflow-hidden')
        : el.classList.remove('overflow-hidden')
    },
    modificaDetalhes(objDetalhes) {
      this.objDetalhes = objDetalhes
      this.toggleModal(objDetalhes.toggleModal)
    },
    clickBanner(slide) {
      slide.href && this.$router.push(`/${slide.href}`)
      slide.url && window.open(slide.url, '_blank')
    },
    obterLoja(lojaId) {
      const nId = lojaId > 0 ? lojaId : null
      this.lojaId = nId
      this.toggleModal(false)
      this.obterListaProdutos(nId, null)
    },
    async obterListaProdutos(lojaId, categoriaId) {
      this.loading = true
      await apiService
        .getStore(this.URL_SLUG, lojaId, categoriaId)
        .then((response) => {
          if (response[0]) {
            this.nomeLoja = response[0].nomeLoja

            this.objProducts = response.map((o) => o.listaProdutos)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async obterListaProdutosPorFiltroTexto(lojaId, textoFiltro) {
      this.loading = true
      await apiService
        .getProdutosFiltroTexto(this.URL_SLUG, lojaId, textoFiltro)
        .then((response) => {
          if (response[0]) {
            this.nomeLoja = response[0].nomeLoja

            this.objProducts = response.map((o) => o.listaProdutos)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  computed: {
    computerProducts() {
      return this.MODULOS.MARKETPLACE
        ? this.obterListaProdutos(
            null,
            this.$store.state.categoriaSelecionadaId,
          ) && true
        : false
    },
    computerCategoriaSelecionada() {
      return this.$store.state.categoriaSelecionada
    },
    computerPesquisarProduto() {
      return this.$store.state.pesquisarProduto
    },
    selectedPlan() {
      return this.objSignature[0];
    }
  },
}
</script>
<style scoped lang="scss">
.example-slide {
  align-items: center;
  background-color: #666;
  color: #999;
  display: flex;
  font-size: 1.5rem;
  justify-content: center;
  min-height: 10rem;
}
</style>
